
<script setup>
import { ref, defineProps, onMounted, defineEmits, watch } from "vue";
import { useQueryCheckoutURL } from '@/hooks/shopify-hooks/useManageCart';
import { isEnableShopify } from "@/hooks/shopify-hooks/useShopifyConst";
import { _CSR_SHOP_CART_ID, _CSR_ACCESS_TOKEN, _CSR_IS_B2b, _CSR_LOGIN_EMAIL,_CSP_STORENFONT_TOKEN } from '@/const/shopifyConst';
import { useCustomer } from '@/hooks/shopify-hooks/useCustomer';
import { useMultipassCheckoutUrl, useIsAccessTokenValid } from '@/hooks/shopify-hooks/useShopifyUtils';
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { useDeleteLoginStorage } from "@/hooks/shopify-hooks/useShopifyMessageEvent";
import { useGetStorage } from '@/hooks/common/useStorage';
import { updateCustomerCartBuyerIdentity,updateCartBuyerIdentity } from '@/hooks/shopify-hooks/api/useLoginApi';
const {   c4aOAuth2State} = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;
const props = defineProps({
    stateKey: {
		type: String,
		default: ''
	},
	skuInfo: {
		type: Object,
		default: () => {
			return {};
		}
	},
	dataset: {
		type: Object,
		default: () => {
		return {};
		},
	},
	label: {
		type: String,
		default: ""
	},
	// 是否有商品下降
	isDislisted: {
		type: Boolean,
		default: false
	},
	// 是否可用
	isAvailable: {
		type: Boolean,
		default: true
	}
});

const cartId = ref(useGetStorage(_CSR_SHOP_CART_ID));
const isB2b = c4aOAuth2StateNew ? c4aOAuth2StateNew : useGetStorage(_CSR_IS_B2b);
const webUrl = ref('');
const isShow= ref(false);
const isDisabled = ref(false);

const $emitEvents = defineEmits(["checkout"]);

onMounted(async () => {
	if(c4aOAuth2StateNew){
      const cartIdS = useGetStorage(_CSR_SHOP_CART_ID);
      const storefrontToken = useGetStorage(_CSP_STORENFONT_TOKEN);
      const b2bBuyerIdentity = {
        customerAccessToken: storefrontToken,
      };
    await updateCartBuyerIdentity(b2bBuyerIdentity, cartIdS);
  }

	if (!isEnableShopify) {
		isShow.value = false;
		return;
	} else {
		isShow.value = true;
		// 若无购物车id, 显示disabled
		if (!cartId.value) {
			isDisabled.value = true;
		} else{
			useQueryCheckoutURL(cartId.value).then(res => {
		  		// 若无商品, 禁用按钮
				isDisabled.value = res?.cart?.totalQuantity === 0 ? true : false;
				webUrl.value = res?.cart?.checkoutUrl;
			})
		}
	}
})

const checkOut = async () => {
    // 若有商品下架，则弹窗提醒
	if (props.isDislisted) {
		window.igws.$toast.open({
			status: "error",
			text: props?.dataset?.removeDelistedProductText
		});
		return;
	}
	$emitEvents('checkout');
    if (webUrl.value) {
			if (isB2b) {
				if(c4aOAuth2StateNew) {
					window.location.href = handleUrlRemoveChannel(webUrl.value);
				}else {
					window.location.href = handleUrlRemoveChannel(webUrl.value) + '&logged_in=true';
				}
			} else {
				if (useIsAccessTokenValid()) {
					const res = await resetUpdateCustomerCartBuyerIdentity();
					if (res?.cartBuyerIdentityUpdate?.cart?.checkoutUrl) {
						webUrl.value = res?.cartBuyerIdentityUpdate?.cart?.checkoutUrl;
						console.log('--更新webUrl.value', webUrl.value);
						// 若已登录用户，包装一层checkout url, 目的是把登录态,用户信息,地址带过去给shopify
						wrapCheckoutUrl()
					}
				} else {
					// 非登录用户，直接跳
					window.location.href = handleUrlRemoveChannel(webUrl.value);
				}

			}
    }
}

// 更新购物车登录信息
const resetUpdateCustomerCartBuyerIdentity = async () => {
	const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
	const access_token = accessToken?.accessToken;
	const email =  useGetStorage(_CSR_LOGIN_EMAIL);
	const buyerIdentity = {
        customerAccessToken: access_token,
        email: email
    }
	const data = await updateCustomerCartBuyerIdentity(buyerIdentity, cartId.value);
	return data;
}

const wrapCheckoutUrl = async () => {
	const { domain, countryIsoCode } = shopifyConst;
	const { getCustomer } = useCustomer();
	const customer = await getCustomer();
	// 若当前用户失效(出现在多人同登一个账号的情况，其中一人退出登录)，则直接跳
	if (!customer) {
		await useDeleteLoginStorage();
		window.location.href = handleUrlRemoveChannel(webUrl.value);
		return;
	}
	const accessToken = useGetStorage(_CSR_ACCESS_TOKEN);
	const access_token = accessToken?.accessToken;
	const checkoutUrl = handleUrlRemoveChannel(webUrl.value);
	const date = new Date().toISOString();

	const postData = JSON.stringify({
			"email": customer.email,
			"created_at": date,
			"first_name": customer.firstName,
			"last_name": customer.lastName,
			"return_to": checkoutUrl,
			"addresses": customer?.addresses?.edges?.length ? customer.addresses.edges.map(({ node: address }) => {
					return {
					"address1": address.address1,
					"address2": address.address2,
					"city": address.city,
					"country": address.country,
					"first_name": address.firstName,
					"last_name": address.lastName,
					"phone": address.phone,
					"province": address.province,
					"zip": address.zip,
					"province_code": address.provinceCode,
					"country_code": countryIsoCode,
					"default": (address.id === customer?.defaultAddress?.id)
					}
			}) : []
		});
	const response = await useMultipassCheckoutUrl(access_token, postData);
	if (response && response.token) {
		window.location.href = 'https://' + domain + '/account/login/multipass/' + encodeURIComponent(response.token);
	} else if (response.value === 'ISC-924') {
		// 墨西哥若接口返回报错ISC-924，去掉channel, 直接跳
		window.location.href = handleUrlRemoveChannel(webUrl.value);
	}
}

const handleUrlRemoveChannel = (url) => {
	const [base, query] = url.split('?');
	const params = new URLSearchParams(query);
	params.delete('channel');
	const cleanedUrl = base + (params.toString() ? '?' + params.toString() : '');
	return cleanedUrl;
}

watch(() => props.isAvailable, (newVal) => {
  isDisabled.value = !newVal;
});

</script>

<template>
  <div class="csr-cp-checkout">
		<button :class="['csr-cp-checkout_btn', dataset.className]" @click="checkOut" v-if="isShow" :disabled="isDisabled">{{ dataset.buttonLabel || label }}</button>
  </div>
</template>

<style scoped lang="less">
</style>